import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NumberFormattingService {


  public formatAmount(amount: number): string {
    if (amount) {
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return undefined;
  }
}
